import { Injectable } from '@angular/core'

import { ClipboardProvider } from '@ti/core/contracts/clipboard'

@Injectable()
export class BrowserClipboard extends ClipboardProvider {
  public async writeText(text: string): Promise<void> {
    if (!navigator.clipboard) {
      throw new Error('Clipboard API not available in this browser.')
    }
    await navigator.clipboard.writeText(text)
  }

  public async readText(): Promise<string> {
    if (!navigator.clipboard) {
      throw new Error('Clipboard API not available.')
    }
    return await navigator.clipboard.readText()
  }
}

export const provideBrowserClipboard = () => ({
  provide: ClipboardProvider,
  useClass: BrowserClipboard,
})
